<a class="mm-help-icon-link"
    [title]="title" [href]="link" target="_blank">
    <app-icon class="mm-help-icon-link-icon" icon="circle-question"></app-icon>
</a>
